import { useState, useEffect } from "react";
import PlotComponent from "./PlotComponent";
import axios from "axios";
import GetAppIcon from '@mui/icons-material/GetApp';

function CyclePlot({cellId,CellCycleData,downloadFile}) {
  const [plotData, setPlotData] = useState([]);
  const [plotData2, setPlotData2] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.BACKEND_URL}batteries/capacity_vs_cycle/${cellId}`)
      .then(response => {
        setPlotData(response.data);
      })
      .catch(error => {
        console.error('Error fetching cycle plot data:', error);
      });

    axios.get(`${process.env.BACKEND_URL}batteries/ir_vs_capacity/${cellId}`)
      .then(response => {
        setPlotData2(response.data);
      })
      .catch(error => {
        console.error('Error fetching cycle plot resistance data:', error);
      });
  }
  , [cellId]);

  return (
    <>
      <div className="flex flex-col border border-[#e8432d29] bg-[#111111] rounded-lg p-4 my-20 py-10 max-w-[1400px] mx-auto">
        <h1 className="text-2xl text-[white] text-center">
        Cell Aging Reference Data : Capacity vs Cycles
        </h1>
        <PlotComponent plotData={plotData} />
        <div className='flex justify-center gap-4'>
            <a className="bg-[#d98532] text-white px-4 py-2 rounded-md cursor-pointer" onClick={() => downloadFile(CellCycleData)}>
              Download Cell Cycling Data
                 <GetAppIcon />
            </a>
        </div>
      </div>
      <div className="flex flex-col border border-[#e8432d29] bg-[#111111] rounded-lg p-4 my-20 py-10 max-w-[1400px] mx-auto">
      <h1 className="text-2xl text-[white] text-center">
      Cell Aging Reference Data : Internal Resistance vs Cycles
        </h1>
        <PlotComponent plotData={plotData2} />
        <div className='flex justify-center gap-4'>
            <a className="bg-[#d98532] text-white px-4 py-2 rounded-md cursor-pointer" onClick={() => downloadFile(CellCycleData)}>
              Download Cell Cycling Data
                 <GetAppIcon />
            </a>
        </div>
      </div>
    </>
  );
}

export default CyclePlot;
